import PropTypes from 'prop-types';
import React from 'react';
import Popup from "reactjs-popup";
import AsyncSelect from 'react-select/async';
import darkSelectStyles from '../../../../shared/darkSelectStyles';
const axios = require('axios').default;

const contentStyle = {
  "border": "none",
  "borderRadius": "8px",
  "boxShadow": "0 0 1px 1px rgba(0,0,0,0.02), 0 4px 6px 1px rgba(0,0,0,0.06)",
  "width": "265px",
  "background": "var(--sl-bg-primary)",
  "color": "var(--sl-text-primary)"
}

const debounce = (func, delay) => {
  let timeoutId;
  return (...args) => {
    clearTimeout(timeoutId);
    return new Promise((resolve) => {
      timeoutId = setTimeout(() => {
        resolve(func(...args));
      }, delay);
    });
  };
};

const promiseOptions = (inputValue, url) => {
  if (!inputValue || inputValue.length < 3) {
    return Promise.resolve([]);
  }

  return axios.get(url, {
      params: {
        name: inputValue
      }
    })
    .then(function (response) {
      var newOptions = response.data.map(function(data){
        return { value: data.name, label: data.name };
      });
      return newOptions;
    })
    .catch(function (error) {
      console.error('Error fetching options:', error);
      return [];
    });
};

const debouncedPromiseOptions = debounce(promiseOptions, 500);

const DebouncedSearchFilter = ({ filter, updateFilter }) => (
  <div className="filter-pill-container mr-2 my-3">
    <Popup arrow={false}
           offsetY={5}
           position="bottom left"
           contentStyle={contentStyle}
           trigger={open => (
      <span className={"filter-pill clickable " + (open ? " opened " : "") + (filter.value.length > 0 ? " filtering " : "")}>
        <span className="px-1">{filter.label}</span>
        {filter.value.length === 0 &&
          <strong className="px-2">All</strong>
        }
        {filter.value.length === 1 &&
          <strong className="px-2">{filter.value[0]}</strong>
        }
        <i className="fa fa-chevron-down px-1"></i>
      </span>
    )} >
      {close => (
        <div>
          <AsyncSelect
            cacheOptions
            styles={darkSelectStyles}
            placeholder={"Type to search..."}
            noOptionsMessage={({ inputValue }) => {
              if (!inputValue || inputValue.length < 3) {
                return "Keep typing to search...";
              }
              return "No results found";
            }}
            onChange={(option) => {
              if (option) {
                updateFilter(filter, option.value);
                close();
              }
            }}
            loadOptions={(inputValue) => debouncedPromiseOptions(inputValue, filter.optionsUrl)}
          />
        </div>
      )}
    </Popup>
  </div>
);

DebouncedSearchFilter.propTypes = {
  filter: PropTypes.object.isRequired,
  updateFilter: PropTypes.func.isRequired
};

export default DebouncedSearchFilter;

